import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export const BACKEND = BACKEND_URL;
export const fileUrl = (path) => (path?.startsWith("http") ? path : `${API_BASE}/files/${path}`);
export default api;
